// lib/axiosInstance.ts
import axios from 'axios';
import StaticValue from '@/lib/StaticValue';

const axiosInstance = axios.create({
    baseURL: StaticValue.baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});
export default axiosInstance;